"use client";

import React from "react";
import { TrendingDown, Clock, Link2 } from "lucide-react";
import { Card, CardHeader, CardTitle, CardDescription, CardContent } from "@/components/ui/card";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
const benefits = [{
  id: "01",
  title: "Budget Friendly",
  description: "Slash your food expenses by up to 50% by splitting large portions. Get premium Toronto eats at student-friendly prices.",
  icon: TrendingDown
}, {
  id: "02",
  title: "Social Dining",
  description: "Connect with nearby foodies in real-time. Turn a quick bite into a social event with our instant matching system.",
  icon: Clock
}, {
  id: "03",
  title: "Zero Waste",
  description: "Join the sustainable food revolution. Shared orders mean fewer containers and zero leftovers going to the landfill.",
  icon: Link2
}];
export default function TheEdgeOfAgenticEfficiency() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return <section data-section-id="134752" id="why-students-love-us" className="dark bg-background text-foreground py-24 px-6 md:px-12 lg:px-24 relative overflow-hidden">
      {}
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[800px] h-[800px] bg-primary/10 rounded-full blur-[120px] pointer-events-none" />

      <div ref={ref} className={`max-w-7xl mx-auto transition-all duration-1000 ease-out ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-12"}`}>
        <div className="text-center mb-16 space-y-4">
          <h2 className="text-3xl md:text-5xl font-black tracking-tighter text-foreground uppercase">
            Why Students Love Us
          </h2>
          <p className="text-lg text-muted-foreground max-w-2xl mx-auto font-medium">
            The smartest way to eat in Toronto. Join thousands of students saving money and making friends through shared orders.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          {benefits.map((benefit, i) => {
          const Icon = benefit.icon;
          return <div data-index={i} key={benefit.id} className="h-full">
                <Card className="h-full bg-card/40 backdrop-blur-xl border-border/50 rounded-sm relative overflow-hidden group transition-all duration-500 hover:-translate-y-2 hover:shadow-[0_0_40px_-10px_var(--color-primary)] hover:border-primary/50 hover:bg-card/60">
                  {}
                  <div className="absolute top-4 right-6 text-6xl font-black font-mono text-muted/10 transition-colors duration-500 group-hover:text-primary/10 select-none pointer-events-none">
                    {benefit.id}
                  </div>

                  <CardHeader className="relative z-10 pb-4">
                    <div className="size-14 rounded-sm bg-background/50 border border-border/50 flex items-center justify-center mb-6 group-hover:border-primary/30 transition-colors duration-500">
                      <Icon className="size-7 text-primary transition-transform duration-500 group-hover:scale-110" strokeWidth={1.5} />
                    </div>
                    <CardTitle className="text-2xl font-black text-foreground group-hover:text-primary transition-colors duration-300 uppercase tracking-tighter">
                      {benefit.title}
                    </CardTitle>
                  </CardHeader>
                  
                  <CardContent className="relative z-10">
                    <CardDescription className="text-base text-muted-foreground leading-relaxed font-medium">
                      {benefit.description}
                    </CardDescription>
                  </CardContent>

                  {}
                  <div className="absolute bottom-0 left-0 w-full h-[2px] bg-gradient-to-r from-transparent via-primary to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-500" />
                </Card>
              </div>;
        })}
        </div>
      </div>
    </section>;
}